import View from './view';

export const ProfileUserPhoneConfirmation = View;
